import fr from './languages/fr.json'
import en from './languages/en.json'
import {
  flattenDictionary,
  TNestedDictionary,
} from '../utils/translation.functions'

/**
 * Bundled translations flattened to `namespace:key` form, used as a local
 * fallback by the API-backed translation system. Generic / static wording
 * (common, days, permissions, errors...) lives here so it renders instantly
 * and is no longer shipped per-client by `/api/dictionary`.
 */
export const LOCAL_TRANSLATIONS: Record<string, Record<string, string>> = {
  fr: flattenDictionary(fr as TNestedDictionary),
  en: flattenDictionary(en as TNestedDictionary),
}

export const DEFAULT_LANGUAGE = 'fr'
